export default {
      id: "icon-aubergine-usage",
      viewBox: "0 0 83.4 89.1",
      url: __webpack_public_path__ + "icons.svg#icon-aubergine",
      toString: function () {
        return this.url;
      }
    }